import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientStatusPage from './pages/ClientStatusPage';
import ContactForm from './pages/ContactForm';
import Step2Page from './pages/Step2Page';
import Selection from './pages/Selection';
import Invitation from './pages/Invitation'; // Importez le nouveau composant Invitation

import './App.css';
import logoFr from './assets/images/logo.png';
import logoEn from './assets/images/logo_en_anglais.png';
import enFlag from './assets/images/drapeau_anglais.png';
import frFlag from './assets/images/drapeau_francais.png';
import { FaUserPlus } from 'react-icons/fa';

import { AlertDialogProvider } from './contexts/AlertDialogContext';

function App() {
  return (
    <Router>
      <AlertDialogProvider>
        <AppContent />
      </AlertDialogProvider>
    </Router>
  );
}

function AppContent() {
  const { t, i18n } = useTranslation();
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const languageModalTimerRef = useRef(null);

  const closeLanguageModal = () => {
    setShowLanguageModal(false);
    if (languageModalTimerRef.current) {
      clearTimeout(languageModalTimerRef.current);
      languageModalTimerRef.current = null;
    }
  };

  useEffect(() => {
    if (showLanguageModal) {
      languageModalTimerRef.current = setTimeout(() => {
        closeLanguageModal();
      }, 5000); // Close after 5 seconds
    } else if (languageModalTimerRef.current) {
      clearTimeout(languageModalTimerRef.current);
      languageModalTimerRef.current = null;
    }

    return () => {
      if (languageModalTimerRef.current) {
        clearTimeout(languageModalTimerRef.current);
      }
    };
  }, [showLanguageModal]);
  const location = useLocation();
  const [showWelcomeModal, setShowWelcomeModal] = useState(location.pathname === '/home'); // State for the welcome modal

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on route change

    if (location.pathname === '/home') {
      const timer = setTimeout(() => {
        setShowWelcomeModal(false);
      }, 3000); // Close after 3 seconds
      return () => clearTimeout(timer); // Clear timeout on unmount
    } else {
      setShowWelcomeModal(false);
    }
  }, [location.pathname]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowLanguageModal(false);
  };

  const handleInscriptionClick = () => {
    console.log("Inscription button clicked!");
    setShowWelcomeModal(false); // Close modal on inscription
  };

  return (
      <div className="App">
          <header className="app-header">
              <div className="header-left">
                  <img
                      src={i18n.language === "en" ? logoEn : logoFr}
                      alt="Logo"
                      className="header-logo"
                  />
              </div>
              <div className="header-right">
                  <button
                      onClick={() => setShowLanguageModal(true)}
                      className="language-button"
                  >
                      {i18n.language === "en" ? (
                          <img
                              src={enFlag}
                              alt={t("app.english")}
                              className="current-flag"
                          />
                      ) : (
                          <img
                              src={frFlag}
                              alt={t("app.french")}
                              className="current-flag"
                          />
                      )}
                  </button>
              </div>
          </header>
          <Routes>
              <Route path="/" element={<ContactForm />} />
              <Route path="/home" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/step2" element={<Step2Page />} />
              <Route path="/selection" element={<Selection />} />
              {/* VOS DEUX ROUTES VERS LE MÊME COMPOSANT */}
              <Route path="/formation" element={<Invitation />} />
              <Route path="/merci-formation" element={<Invitation />} />{" "}
              {/* <--- AJOUTEZ CETTE LIGNE */}
              <Route path="/ClientStatusPage" element={<ClientStatusPage />} />
          </Routes>

          {showLanguageModal && (
              <div
                  className="language-modal-overlay"
                  onClick={closeLanguageModal}
              >
                  <div
                      className="language-modal-content"
                      onClick={(e) => e.stopPropagation()}
                  >
                      <h3>{t("app.select_language")}</h3>
                      <div className="language-options">
                          <img
                              src={enFlag}
                              alt={t("app.english")}
                              className="flag-icon"
                              onClick={() => changeLanguage("en")}
                          />
                          <img
                              src={frFlag}
                              alt={t("app.french")}
                              className="flag-icon"
                              onClick={() => changeLanguage("fr")}
                          />
                      </div>
                      <button
                          onClick={closeLanguageModal}
                          className="close-modal-button"
                      >
                          X
                      </button>
                  </div>
              </div>
          )}
      </div>
  );
}

export default App;